<div>
    <app-mwe-table  [columns]="columns" [showHeader]="false" [data]="allDistributors"  (selectedAction)="selectedAction($event)" [currentPageChanged]="pageIndex"   
    (pageChanged)="onPageChanged($event)" [isDynemicPagination]="false" [totalEntries]="totalEntries"></app-mwe-table>
    <!-- <h2 *ngIf="showNoRecordsFounds" class="no-records">No records found</h2>  -->
    <div *ngIf="showNoRecordsFounds"  class="no-results">
        <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
        <div class="no-records-found"> No Distributors Found </div>
      </div>
 </div>